/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import { Fragment } from 'react';
import {
  Button,
  Collapse,
  DropdownItem,
  DropdownToggle,
  DropdownMenu as ReactDropdownMenu,
  UncontrolledDropdown,
} from 'reactstrap';
import SimpleTooltip from '../../../../../components/simple-tooltip';
import { ellipsis } from '../../../../../utils';
import { CustomDashboardInfoIcon } from '../../../../custom-dashboard/CustomDashboardInfoIcon';
import { AddDashboardOption, InsightDashboardOption, TOOLTIP_MESSAGE } from '../../utils/sidebar';

interface SidebarProps {
  options: (InsightDashboardOption | AddDashboardOption)[];
  currentPage: string;
  className?: string;
  handleClickOption: (item: InsightDashboardOption | AddDashboardOption) => () => void;
}

export const InsightsSidebar = (props: SidebarProps) => {
  const { options, currentPage, handleClickOption, className } = props;
  return (
    <>
      <div className={`d-inline-block d-xxl-none insights-dropdown-container ${className}`}>
        <UncontrolledDropdown size='sm'>
          <DropdownToggle color='transparent' outline caret>
            {options.find((i) => i.value === currentPage)?.label ?? ''}
          </DropdownToggle>
          <ReactDropdownMenu>
            {options.map((item) => (
              <SimpleTooltip key={`insights_dropdown_${item.value}`} text={item.tooltip}>
                <DropdownItem disabled={item.disabled} onClick={handleClickOption(item)}>
                  {item.label}
                  <CustomDashboardInfoIcon text={item.isSharedByParent ? TOOLTIP_MESSAGE.IS_SHARED_BY_PARENT : ''} />
                </DropdownItem>
              </SimpleTooltip>
            ))}
          </ReactDropdownMenu>
        </UncontrolledDropdown>
      </div>
      <div className='d-none d-xxl-inline-block insights-sidebar-container settings-sidebar-container'>
        <div className='sticky-sidebar'>
          {options.map((item) => (
            <Fragment key={`sidebar_${item.value}`}>
              {item.value !== currentPage ? (
                <div>
                  {item.isCustom && typeof item.label === 'string' ? (
                    <SimpleTooltip text={item.tooltip ?? item.label}>
                      <Button color='transparent' disabled={item.disabled} onClick={handleClickOption(item)}>
                        {ellipsis(item.label, 11)}
                      </Button>
                    </SimpleTooltip>
                  ) : (
                    <SimpleTooltip text={item.tooltip}>
                      <Button color='transparent' disabled={item.disabled} onClick={handleClickOption(item)}>
                        {item.label}
                      </Button>
                    </SimpleTooltip>
                  )}
                  <CustomDashboardInfoIcon text={item.isSharedByParent ? TOOLTIP_MESSAGE.IS_SHARED_BY_PARENT : ''} />
                </div>
              ) : null}
              <Collapse isOpen={item.value === currentPage} className='sidebar-title strong'>
                <span className='my-3'>
                  {item.isCustom && typeof item.label === 'string' ? (
                    <SimpleTooltip text={item.label}>{ellipsis(item.label, 11)}</SimpleTooltip>
                  ) : (
                    item.label
                  )}
                </span>
              </Collapse>
            </Fragment>
          ))}
        </div>
      </div>
    </>
  );
};
